import _toConsumableArray from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import _regenerator from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
export default {
  name: "SelectLazyLoad",
  components: {},
  props: {
    isObjType: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: 2
    },
    placeholder: {
      type: String,
      default: "请选择"
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showLabel: {
      type: Boolean,
      default: false
    },
    selectList: {
      type: Array | String,
      default: ""
    },
    labelTitle: {
      type: String,
      default: function _default() {
        return "";
      }
    },
    filterCallBack: {
      type: Function,
      default: function _default() {}
    },
    // 在非接口请求时使用的数据
    dataList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /**
     * @propsValue 下拉框中的value的键
     * @propsLabel 下拉框中的label的键
     */
    propsValue: {
      type: String,
      default: function _default() {
        return "value";
      }
    },
    propsLabel: {
      type: String,
      default: function _default() {
        return "label";
      }
    },
    /**
     * @param dataSource
     * false: 默认以传入data进行下拉框操作
     * true: 通过函数获取data数据进行下拉框操作
     */
    dataSource: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    pageSize: {
      type: Number | String,
      default: function _default() {
        return 20;
      }
    },
    // 返回的数据结构
    resultStructure: {
      type: String,
      default: function _default() {
        return "data.rows";
      }
    },
    // 查询字段名称
    searchName: {
      type: String,
      default: function _default() {
        return "name";
      }
    },
    editorSatatus: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    isFirstShow: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      selectEle: "",
      list: [],
      dataListFilter: [],
      scrollIndex: 1,
      loading: false,
      SELECTWRAP_DOM: null,
      search_name: "",
      dataFilterFlag: false,
      // 控制接口请求
      endLoading: false,
      timer: null,
      hideByClear: false,
      visibleChangeStatus: false
    };
  },
  watch: {
    dataList: {
      handler: function handler(v, o) {
        if (this.dataSource) return;
        this.getTruckNoList();
      },
      deep: true,
      immediate: true
    },
    selectList: {
      handler: function handler(v, o) {
        var _this = this;
        if (this.editorSatatus && this.selectList && this.selectList.length) {
          this.$nextTick(function () {
            _this.selectEle = _this.selectList;
          });
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            this.SELECTWRAP_DOM = this.$refs.ykSelectlazyload.$el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
            this.SELECTWRAP_DOM.addEventListener("scroll", this.infinityload);
            console.log("dataSource mounted");
            if (!this.dataSource) {
              _context.n = 1;
              break;
            }
            _context.n = 1;
            return this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  created: function created() {},
  destroyed: function destroyed() {
    this.SELECTWRAP_DOM.removeEventListener("scroll", this.infinityload);
  },
  methods: {
    getEditorData: function getEditorData(list) {
      return Promise.all(list);
    },
    clearChoose: function clearChoose() {
      this.selectEle = null;
    },
    getData: function () {
      var _getData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this2 = this;
        var params, info, resultStructure, data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              console.log("search_name", this.search_name);
              // if (!this.search_name) return;
              params = {
                pageSize: this.pageSize,
                pageNum: this.scrollIndex
              };
              params[this.searchName] = this.search_name;
              this.loading = true;
              _context2.n = 1;
              return this.filterCallBack(this.$filterObj(params));
            case 1:
              info = _context2.v;
              this.dataFilterFlag = false;
              this.loading = false;
              try {
                if (info && info.code === 200) {
                  if (info.data.pages <= this.scrollIndex) {
                    this.endLoading = true;
                  } else {
                    this.endLoading = false;
                  }
                  resultStructure = this.resultStructure.split(".");
                  data = this.getResultStructure(info, resultStructure);
                  data = data ? data : [];
                  // 单独处理 返回的字符串数据
                  data = data.map(function (item) {
                    var obj = item;
                    if (typeof item === "string") {
                      obj = {
                        label: item,
                        value: item
                      };
                    }
                    return obj;
                  });
                  this.list = this.list.concat(data);
                  this.$nextTick(function () {
                    _this2.scrollIndex++;
                  });
                }
              } catch (e) {
                console.log(e);
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getData() {
        return _getData.apply(this, arguments);
      }
      return getData;
    }(),
    getResultStructure: function getResultStructure(data, list) {
      var key = list.shift();
      var d = data[key];
      if (list.length) {
        d = this.getResultStructure(d, list);
      }
      return d;
    },
    infinityload: function infinityload() {
      var _this3 = this;
      var CONDITION = this.SELECTWRAP_DOM.scrollHeight - this.SELECTWRAP_DOM.scrollTop <= this.SELECTWRAP_DOM.clientHeight + 5;
      if (CONDITION) {
        console.log("===scrollIndex==infinityload====>" + this.dataSource, this.dataFilterFlag);
        if (this.dataSource) {
          if (this.dataFilterFlag || this.endLoading) return;
          this.dataFilterFlag = true;
          setTimeout(function () {
            _this3.getData();
          }, 500);
        } else {
          this.load();
        }
      }
    },
    load: function load() {
      var _this4 = this;
      this.list = this.dataListFilter.filter(function (item, index) {
        return index < (_this4.scrollIndex + 1) * 20;
      });
      this.$nextTick(function () {
        _this4.scrollIndex++;
      });
    },
    getTruckNoList: function getTruckNoList() {
      var _this$list,
        _this5 = this;
      this.dataListFilter = _toConsumableArray(this.dataList);
      var data = this.dataList.filter(function (item, index) {
        return index < 20;
      });
      (_this$list = this.list).push.apply(_this$list, _toConsumableArray(data));
      this.$nextTick(function () {
        _this5.scrollIndex++;
      });
    },
    filtermethod: function filtermethod(v) {
      var _this6 = this;
      console.log("filtermethod", v);
      this.scrollIndex = 1;
      clearTimeout(this.timer);
      if (this.dataSource) {
        if (!v || v.length >= this.maxLength) {
          this.dataFilterFlag = true;
          // 500毫秒后开始查询
          this.timer = setTimeout(function () {
            _this6.dataFilter_02(v);
          }, 500);
        }
      } else {
        this.dataFilter_01(v);
      }
    },
    dataFilter_01: function dataFilter_01() {
      var _this7 = this;
      var v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      this.list.splice(0, this.list.length);
      this.list = [];
      this.$nextTick(function () {
        var _this7$list;
        _this7.dataListFilter = _this7.dataList.filter(function (item) {
          return item[_this7.propsLabel].indexOf(v) !== -1;
        });
        var data = _this7.dataListFilter.filter(function (item, index) {
          return index < 20;
        });
        (_this7$list = _this7.list).push.apply(_this7$list, _toConsumableArray(data));
        _this7.$nextTick(function () {
          _this7.SELECTWRAP_DOM.scrollTop = 0;
        });
      });
    },
    dataFilter_02: function dataFilter_02() {
      var v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      this.list = [];
      this.search_name = v.trim();
      this.getData();
    },
    change: function change(v) {
      this.parentEmit(v);
    },
    clearSelector: function clearSelector() {
      this.scrollIndex = 1;
      if (this.visibleChangeStatus) {
        this.hideByClear = true;
      }
      if (this.dataSource) {
        this.dataFilter_02();
      } else {
        this.dataFilter_01();
      }
      this.parentEmit();
    },
    visibleChangeSelector: function visibleChangeSelector(flag) {
      console.log("visibleChangeSelector", flag);
      this.visibleChangeStatus = flag;
      if (!flag) {
        if (this.list.length === 0) {
          this.selectEle = null;
        }
        if (this.hideByClear) {
          this.hideByClear = false;
        } else {
          if (!this.selectEle && this.selectEle !== 0) {
            this.scrollIndex = 1;
            if (this.dataSource) {
              this.dataFilter_02();
            } else {
              this.dataFilter_01();
            }
            console.log("visibleChangeSelector", this.selectEle);
            this.parentEmit();
          }
        }
      }
    },
    parentEmit: function parentEmit() {
      var v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      this.$emit("update:selectList", v);
      this.$emit("change", v);
    }
  }
};